import { Stack } from '@mui/material';
import { DimentionField } from '@/components';
import { useNode } from '@craftjs/core';
import { DimentionTypes } from '@/components/dimention-field/DimentionField';
import useResponsiveValues from '@/components/editor/hooks/useResponsiveValues';
import { DimentionProps } from './types';

const DimentionSettings = () => {
  const {
    props,
    actions: { setProp },
  } = useNode((node) => ({
    props: node.data.props,
  }));

  const responsive = useResponsiveValues();

  return (
    <Stack spacing={2}>
      <Stack spacing={2} direction="row">
        <DimentionField
          label="Ancho"
          value={responsive.getValue(props.width)}
          setValue={(value: string) => {
            setProp((props: DimentionProps) => {
              props.width = responsive.setValue(props.width, value);
              return props;
            });
          }}
          type={responsive.getValue(props.widthType) as DimentionTypes}
          setType={(value: DimentionTypes) => {
            setProp((props: DimentionProps) => {
              props.widthType = responsive.setValue(props.widthType, value);
              return props;
            });
          }}
        />
        <DimentionField
          label="Ancho Máximo"
          value={responsive.getValue(props.maxWidth)}
          setValue={(value: string) => {
            setProp((props: DimentionProps) => {
              props.maxWidth = responsive.setValue(props.maxWidth, value);
              return props;
            });
          }}
          type={responsive.getValue(props.maxWidthType) as DimentionTypes}
          setType={(value: DimentionTypes) => {
            setProp((props: DimentionProps) => {
              props.maxWidthType = responsive.setValue(props.maxWidthType, value);
              return props;
            });
          }}
        />
      </Stack>
      <Stack spacing={2} direction="row">
        <DimentionField
          label="Alto"
          value={responsive.getValue(props.height)}
          setValue={(value: string) => {
            setProp((props: DimentionProps) => {
              props.height = responsive.setValue(props.height, value);
              return props;
            });
          }}
          type={responsive.getValue(props.heightType) as DimentionTypes}
          setType={(value: DimentionTypes) => {
            setProp((props: DimentionProps) => {
              props.heightType = responsive.setValue(props.heightType, value);
              return props;
            });
          }}
        />
        <DimentionField
          label="Alto Máximo"
          value={responsive.getValue(props.maxHeight)}
          setValue={(value: string) => {
            setProp((props: DimentionProps) => {
              props.maxHeight = responsive.setValue(props.maxHeight, value);
              return props;
            });
          }}
          type={responsive.getValue(props.maxHeightType) as DimentionTypes}
          setType={(value: DimentionTypes) => {
            setProp((props: DimentionProps) => {
              props.maxHeightType = responsive.setValue(props.maxHeightType, value);
              return props;
            });
          }}
        />
      </Stack>
    </Stack>
  );
};

export default DimentionSettings;
